<template>
  <!-- Other homes in the area, on the page of an archived listing. The API picks them
       (ad.nearby: live listings with a photo in the same postcode area, most wanted first)
       in the same shape as the front page's list, so the cards look like the front page's. -->
  <section v-if="listings && listings.length" class="nearby-listings">
    <h2>Bostäder i närheten</h2>
    <div class="nearby-grid">
      <router-link
        v-for="bostad in listings"
        :key="bostad.id"
        :to="{ name: 'ad', params: { id: bostad.id } }"
        class="nearby-item">
        <img :src="'https://bytbostad.se/bilder/square/' + bostad.photo + '.jpg'" :alt="bostad.address" @error="errorImage">
        <div class="nearby-text">
          <span>{{ bostad.rooms }}:a {{ bostad.size }} m<sup>2</sup></span>
          {{ bostad.address }}<br>
          <span class="nearby-city">{{ bostad.city }}</span>
        </div>
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NearbyListings',
  props: {
    listings: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    errorImage (event) {
      event.target.src = '/img/nophoto.svg'
    }
  }
}
</script>

<style lang="scss" scoped>
.nearby-listings{
  margin: 30px 0 10px;

  h2{ margin-bottom: 12px; }
}
.nearby-grid{
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  grid-gap: 8px;

  @media screen and (max-width: 650px) {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }
}
.nearby-item{
  position: relative;
  display: block;
  aspect-ratio: 1/1;
  border-radius: 8px;
  overflow: hidden;
  background-color: #d8d8d8;

  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.nearby-text{
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  display: grid;
  place-content: center;
  text-align: center;
  color: white;
  font-size: 12px;
  background-color: rgba(0, 0, 0, 0.32);
}
.nearby-city{ font-size: 14px; }
</style>
